import { useWhatsNewPath } from '@/release/hooks/useWhatsNewPath'
import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from '@chakra-ui/react'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router'
import { EmailIcon } from 'src/icons'
import settings from 'src/settings'

// « À propos » (#83): the instance, its version, and the free software it
// derives from (MIT, © 2022 Rolebase), with a link to its source; the way to
// the What's new page and to the team (#77).
export default function AboutModal(modalProps: Omit<ModalProps, 'children'>) {
  const { t } = useTranslation()
  const brand = settings.brand.name
  const whatsNewPath = useWhatsNewPath()

  return (
    <Modal size="md" {...modalProps}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('HelpMenu.about', { brand })}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="start" spacing={3}>
            <Text>
              {t('HelpMenu.aboutVersion')} :{' '}
              {settings.version ?? t('SettingsMenu.user.versionUnknown')}
            </Text>
            <Text>
              <Trans
                i18nKey="HelpMenu.aboutText"
                values={{ brand }}
                components={{ b: <strong /> }}
              />
            </Text>
            {settings.sourceUrl && (
              <Link href={settings.sourceUrl} isExternal color="blue.500">
                {t('HelpMenu.aboutSource')} ↗
              </Link>
            )}
            <Link
              as={RouterLink}
              to={whatsNewPath}
              color="blue.500"
              onClick={modalProps.onClose}
            >
              {t('HelpMenu.aboutWhatsNew')}
            </Link>
          </VStack>
        </ModalBody>
        <ModalFooter gap={2} flexWrap="wrap">
          {settings.contactEmail && (
            // The address is never shown: the button opens a mail to it (#77)
            <Button
              as="a"
              href={`mailto:${settings.contactEmail}`}
              leftIcon={<EmailIcon size={18} />}
            >
              {t('HelpMenu.aboutContact', { brand })}
            </Button>
          )}
          <Button onClick={modalProps.onClose}>{t('common.close')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
